import { Theme } from '@material-ui/core';

import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const selectStyles = (theme: Theme, fieldVariant) => {
  const styles = {
    [FieldVariant.dataRow]: {
      root: {
        '& .MuiInputBase-root': {
          marginTop: 0,
          paddingTop: 1,
          paddingBottom: 1,
          display: 'flex',
          justifyContent: 'space-between',
        },
        '& .MuiSelect-root': {
          marginTop: -3,
          paddingBottom: 11,
          width: 'auto',
          color: theme.palette.text.primary,
        },
        '& .MuiSelect-icon': {
          marginTop: '-0.14rem',
        },
      },
    },
    [FieldVariant.form]: {
      root: {
        '& .MuiSelect-root': {
          marginTop: '6.5px',
          alignItems: 'center',
          paddingTop: '0.04rem',
          paddingBottom: '0.16rem',
        },
        '& .MuiInput-formControl': {
          marginTop: '13px !important',
        },
      },
    },
  };

  return styles[fieldVariant];
};
